import { getExerciseTypeVersionAdapter } from '@datacamp/exercise-types';
var exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('CloudExercise', 'v1');
export default exerciseTypeVersionAdapter;